// HTML escape for untrusted text we interpolate into innerHTML strings.
// The app does a lot of template-literal-based rendering (legacy pattern)
// so a single shared helper avoids drift between call sites.

import { tts } from "../api/tts";
import type { Lang } from "../types";

const ENTITIES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(s: unknown): string {
  return String(s).replace(/[&<>"']/g, (c) => ENTITIES[c]!);
}

/** Emit a speak-this-text button with a leading space — clicks are
 *  handled by a global delegate (see api/tts.ts). Returns "" when the
 *  Web Speech API is unsupported (no API surface at all). If the API
 *  exists but no voice matches `lang` at render time, the button is
 *  emitted with the `hidden` attribute; tts.ts un-hides it later when
 *  voiceschanged fires with a usable voice (Chrome/Firefox load voices
 *  asynchronously). */
export function ttsButtonHtml(
  text: string,
  lang: Lang,
  title: string,
): string {
  if (!tts.isSupported()) return "";
  const hidden = tts.hasVoice(lang) ? "" : " hidden";
  return (
    ` <button type="button" class="tts-btn"${hidden}` +
    ` data-tts-text="${escapeHtml(text)}"` +
    ` data-tts-lang="${escapeHtml(lang)}"` +
    ` title="${escapeHtml(title)}"` +
    ` aria-label="${escapeHtml(title)}">♪</button>`
  );
}
